import { ThemeProfile } from './types';

export const shadowGridProfile: ThemeProfile = {
  pageBackground: 'transparent',
  hud: {
    overlayOpacity: 0,
    dotsOpacity: 0,
    showAnimatedGrid: true,
    showGlobalScanline: true,
  },
  cards: {
    background: 'rgba(5, 6, 8, 0.78)',
    border: 'rgba(0, 255, 170, 0.25)',
    shadow: '0 8px 24px rgba(0, 0, 0, 0.35)',
  },
};
